import React from 'react';

import { Paper } from '@material-ui/core';

import {
    useClientAndLocationPaneVisible,
    useMainMapVisible,
} from '../../state/ui/customerService/clientsAndLocations/index.hooks';
import {
    useBottomGrid,
    useBottomGridPaneVisible,
} from '../../state/ui/customerService/bottomGrid/index.hooks';

import TranslationHelper from '../../helpers/TranslationHelper';

import { useStyles } from './Themable.hooks';

import View from '../../components/View';

import EditOverlay from '../../components/EditOverlay';
import MapDialog from './components/MapDialog/MapDialog';
import PageContent from '../../components/PageContent';
import { Box } from '@mui/material';

import CscMap from './components/CscMap';

import { Panel, PanelGroup } from 'react-resizable-panels';
import CustomResizeHandle from '@/app/components/CustomResizeHandle';
import { useFeatureSelection } from './hooks/useFeatureSelection';
import GridSection from './components/GridSection';
import { useBottomGridConfig } from './hooks/useBottomGridConfig';
import ClientServicePane from './components/ClientServicePane';

const CustomerServicePage = () => {
    const mapVisible = useMainMapVisible();
    const classes = useStyles();
    const bottomGrid = useBottomGrid();

    const clientAndLocationPaneVisible = useClientAndLocationPaneVisible();
    const bottomGridVisible = useBottomGridPaneVisible();
    const paneVisible = clientAndLocationPaneVisible || bottomGridVisible;

    const featureSelection = useFeatureSelection();
    const bottomGridConfig = useBottomGridConfig();

    const bottomGridProps = {
        id: bottomGrid,
        sourceSet: bottomGridConfig.getSourceSet(),
        selectedItems: bottomGrid
            ? featureSelection.selectedItems[bottomGrid]
            : [],
        source: featureSelection.bottomGridSource,
        style: bottomGridConfig.getStyle(),
        setSource: featureSelection.setBottomGridSource,
    };

    return (
        <View title={TranslationHelper.translate('Client service')}>
            <PageContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            width: paneVisible ? 'calc(100% - 410px)' : '100%',
                        }}
                    >
                        <PanelGroup
                            key={mapVisible ? 'map-visible' : 'map-hidden'}
                            direction="horizontal"
                            autoSaveId="customer-service"
                        >
                            <Panel defaultSize={mapVisible ? 60 : 100}>
                                <GridSection
                                    locationsSource={
                                        featureSelection.locationsSource
                                    }
                                    selectedItems={
                                        featureSelection.selectedItems
                                    }
                                    onFeatureSelected={
                                        featureSelection.onFeatureSelected
                                    }
                                    lastSelectedLocation={
                                        featureSelection.lastSelectedLocation
                                    }
                                    handleSelectLastItem={
                                        featureSelection.handleSelectLastItem
                                    }
                                    bottomGrid={bottomGrid}
                                    bottomGridSource={
                                        featureSelection.bottomGridSource
                                    }
                                    lastSelectedBottomItem={
                                        featureSelection.lastSelectedBottomItem
                                    }
                                />
                            </Panel>
                            {mapVisible && (
                                <CustomResizeHandle direction="horizontal" />
                            )}
                            {paneVisible && (
                                <Paper className={classes.paneWrapper}>
                                    <ClientServicePane />
                                </Paper>
                            )}
                            <MapDialog />

                            <Panel
                                defaultSize={mapVisible ? 40 : 0}
                                minSize={0}
                            >
                                <Box
                                    sx={{
                                        height: '100%',
                                        width: mapVisible ? '100%' : 0,
                                        overflow: 'hidden',
                                    }}
                                >
                                    <CscMap
                                        locationsSource={
                                            featureSelection.locationsSource
                                        }
                                        handleSelectFeatures={
                                            featureSelection.handleSelectFeaturesOnMap
                                        }
                                        selectedItems={
                                            featureSelection.selectedItems
                                        }
                                        setSource={
                                            featureSelection.setLocationsSource
                                        }
                                        bottomGrid={bottomGridProps}
                                    />
                                </Box>
                            </Panel>
                        </PanelGroup>
                    </Box>
                </Box>
            </PageContent>
            <EditOverlay />
        </View>
    );
};

export default CustomerServicePage;
